import { BrowserRouter } from "react-router";

// Побочный эффект: инициализация i18next. Живёт в слое app, а не в main.tsx,
// потому что это часть настройки приложения — и потому что иначе тесты,
// рендерящие <App/> напрямую, получали бы вместо текстов ключи.
import "@/shared/i18n";

import { AuthProvider } from "@/entities/session";

import { AntdProvider, ErrorBoundary, QueryProvider, useThemeMode } from "./providers";
import { AuthGate } from "./ui/AuthGate";
import { Shell } from "./ui/Shell";

/**
 * Порядок провайдеров существенный:
 *
 *  - `AntdProvider` снаружи `AuthProvider`, потому что форма входа и её
 *    сообщения об ошибках рисуются antd;
 *  - `QueryProvider` снаружи `AuthProvider`: провайдер сессии чистит кэш при
 *    выходе и должен видеть `QueryClient`;
 *  - `BrowserRouter` снаружи `AuthGate`, а не внутри. Форма входа тоже живёт
 *    в роутере: после успешного входа она делает `navigate` на сводку, и без
 *    роутера выше по дереву это падение в рендере, а не редирект.
 */
export function App() {
  const [themeMode, toggleTheme] = useThemeMode();

  return (
    <ErrorBoundary>
      <AntdProvider mode={themeMode}>
        <QueryProvider>
          <AuthProvider>
            <BrowserRouter>
              <AuthGate>
                <Shell themeMode={themeMode} onToggleTheme={toggleTheme} />
              </AuthGate>
            </BrowserRouter>
          </AuthProvider>
        </QueryProvider>
      </AntdProvider>
    </ErrorBoundary>
  );
}
